import {
    Modal,
    ModalDialog,
    ModalClose,
    DialogTitle,
    DialogContent,
    DialogActions,
    Divider,
    Box,
    Typography,
} from "@mui/joy";
import { NewSubTaskInline } from "../../components/Tasks/components";
import { useState } from "react";
import SideModal from "../SideModal";
import { BadgePlus } from "lucide-react";

export function NewEvent(props: {
    showModal: boolean;
    setShowModal: (showModal: boolean) => void;
    selectedDate: any;
    onSubmit: (data: any) => void;
}) {
    const { showModal, setShowModal, selectedDate, onSubmit } = props;
    const [isFormValid, setIsFormValid] = useState(false);

    return (
        <SideModal
            open={showModal}
            onClose={() => setShowModal(false)}
            showAdditionalHeadersIcons={false}
            title="Create Task"
            // description="Create task for individual project and assign to specific user"
        >
            <Box p={2}>
                <NewSubTaskInline
                    selectedDate={selectedDate}
                    onSubmit={(data: any) => {
                        onSubmit(data);
                        setShowModal(false);
                    }}
                    onFormStateChange={setIsFormValid}
                />
            </Box>
        </SideModal>
    );
}
